import { useGetUser } from 'queries';

export function useIsInternalUser(): boolean {
  const { data: user } = useGetUser();

  return user?.type === 'INTERNAL';
}
